export enum FileType {
    PNG = "png",
    JPG = "jpg",
    TEXT = 'txt',
    LAS = 'las',
    SGY = 'sgy',
    CSV = 'csv',
}

export enum ViewType {
    UNKNOW,
    IMAGE,
    CSV,
    TEXT
}

export default function getViewType(fileType: FileType): ViewType {
    switch (fileType) {
        case FileType.JPG:
            return ViewType.IMAGE;
        case FileType.PNG:
            return ViewType.IMAGE;
        case FileType.TEXT:
            return ViewType.TEXT;
        case FileType.LAS:
            return ViewType.TEXT;
        case FileType.CSV:
            return ViewType.CSV;
        default:
            return ViewType.UNKNOW
    }
}